import styled, { css } from 'styled-components';

const Container = styled.div.withConfig({
    displayName: "ErrorScreen.styles__Container",
    componentId: "sc-1f0e4b02-0"
})`
    padding: ${({ theme  })=>`${theme.spacers.L} ${theme.spacers.M}`};

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const Title = styled.h5.withConfig({
    displayName: "ErrorScreen.styles__Title",
    componentId: "sc-1f0e4b02-1"
})`
    margin: 0;
    ${(props)=>css(props.theme.typography.Paragraph)}
    text-align: center;
    line-height: 24px;
    color: ${(props)=>props.theme.colors["Level 4"]};
    padding-top: ${(props)=>props.theme.spacers.XL};
    cursor: default;
`;
const Message = styled.p.withConfig({
    displayName: "ErrorScreen.styles__Message",
    componentId: "sc-1f0e4b02-2"
})`
    margin: 0;
    ${(props)=>css(props.theme.typography.TinyParagraph)}
    text-align: center;
    color: ${(props)=>props.theme.colors["Level 4"]};
    padding: 12px 0;
    cursor: default;
`;
const ContactButton = styled.button.attrs({
    type: "button"
}).withConfig({
    displayName: "ErrorScreen.styles__ContactButton",
    componentId: "sc-1f0e4b02-3"
})`
    /* Reset default browser styles */
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    font: inherit;
    line-height: normal;
    appearance: none;
    &::-moz-focus-inner {
        border: 0;
        padding: 0;
    }
    :focus {
        outline-style: none;
        box-shadow: none;
        border: none;
    }
    /* end of reset */

    ${(props)=>css(props.theme.typography.TinyParagraph)}
    color: ${(props)=>props.theme.colors["Level 4"]};
    text-decoration: underline;

    :hover {
        cursor: pointer !important;
        color: ${(props)=>props.theme.colors["Level 3"]};
    }
`;

export { ContactButton, Container, Message, Title };
